var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"shadow"}),_c('div',{staticClass:"box"})])])
}]

export { render, staticRenderFns }